import ServerSideDataTable from "../../../Feature/DataTable/ServerSideDataTable";
import ModalDatatableItem from "../../../Feature/Modal/ModalDatatableItem";
import AppLoading from "../../../Feature/AppLoading";
import PageDependencies from "../../../Feature/PageDependencies";
import TooltipTemplate from "../../../Layout/AppNav/TooltipTemplate";

const ProjectDataTable = (props) => {
  const { 
    Fragment, 
    useState,
    guid,
    dataExtension,
    getData,
    tryCatchFinally,
    toastPrint,
    stringCoding,
    timeOperation,
    useLocation,
    useNavigate,
    useEffectWithPrevious
  } = PageDependencies();
  const debug = props.debug === undefined ? false : props.debug;
  const emptyGuid = guid.emptyGuid();
  const currentUrl = useLocation().pathname;
  const nav = useNavigate();
  const redirectUrlHex = stringCoding.encode(currentUrl);
  const [modal, setModal] = useState({
    isOpen: false,
    title: "",
    message: "",
    comfirmButtonStyle: "",
    comfirmButtonText: "Comfirm",
    handleComfirm: () => {},
  });
  const [loading, setLoading] = useState({isLoading:false,text:""});
  const [data, setData] = useState([]);
  const tableId = "Project_99998d90-e946-4514-9300-45dcdb39157a";
  const tableReload = props.tableReload;
  const setTableReload = props.setTableReload;
  const extraPostModelProject = props.extraPostModelProject;
  const setExtraPostModelProject = props.setExtraPostModelProject;
  const extraPostModelDevelopment = props.extraPostModelDevelopment;
  const userName = props.userName;
  
  const columns = [
    { name: "name", text: "Name", width: "20%" },
    { name: "address", text: "Address", width: "20%" },
    { name: "developmentName", text: "Development", width: "20%" },
    { name: "starRating", text: "Star rating", width: "20%" },
    { name: "submittedDate", text: "Submitted Date", width: "20%" },
  ];

  const items = {
      new: {
        name: "New",
        icon: "add",
        url: "/ProjectAssessor/Detail/" + getSelectedDevelopmentId() + "/" + guid.emptyGuid(),
        defaultAction: true,
      },
      separator: "---------",
      edit: {
        name: "Edit",
        icon: "edit",
        url: "/ProjectAssessor/Detail/" + getSelectedDevelopmentId() + "/",
        defaultAction: true,
          disabled: function () {
          return dataExtension.getSelectedRowDataIds(data).length !== 1;
        },
      },
      delete: {
        name: "Delete",
        icon: "delete",
        url: "",
        defaultAction: false,
        disabled: function () {
          return dataExtension.getSelectedRowDataIds(data).length === 0;
        },
      },
      duplicate: {
        name: "Duplicate",
        icon: "copy",
        url: "",
        defaultAction: false,
        disabled: function () {
          return dataExtension.getSelectedRowDataIds(data).length === 0;
        },
      },
      duplicateIncludeDevelopment: {
        name: "Duplicate including Development",
        icon: "copy",
        url: "",
        defaultAction: false,
        disabled: function () {
          return dataExtension.getSelectedRowDataIds(data).length === 0;
        },
      },
    };

      const authorityAccounts = [
        "accurateenterprise.admin@csiro.au",
        "accurateenterprise.assessor@csiro.au",
        "ai.jian@csiro.au",
        "alice.wade1@dcceew.gov.au",
        "andrew.law@csiro.au",
        "angela.rojas@csiro.au",
        "batch.testing@nathers.gov.au",
        "Ben.Kennedy@dcceew.gov.au",
        "bradley.lane@csiro.au",
        "Brendan.Chan@dcceew.gov.au",
        "christine.kerr@dcceew.gov.au",
        "clare.smith@dcceew.gov.au",
        "daniel.daly@dcceew.gov.au",
        "daniella.amiyants1@dcceew.gov.au",
        "dave.brunoro1@dcceew.gov.au",
        "ellen.pearson@dcceew.gov.au",
        "Grady.Peterson@dcceew.gov.au",
        "John.DAVEY@dcceew.gov.au",
        "Katie.Glendenning@dcceew.gov.au",
        "lachlan.brennan@dcceew.gov.au",
        "lachlan.cheers@csiro.au",
        "Lachlan.Mudge@dcceew.gov.au",
        "lan359@csiro.au",
        "matt.marchesi@dcceew.gov.au",
        "Melanie.Lupis@dcceew.gov.au",
        "michael.ambrose@csiro.au",
        "ming.liu1@csiro.au",
        "nesreen.abumousa@dcceew.gov.au",
        "Rowan.Hearne@dcceew.gov.au",
        "Shlomi.Bonet@dcceew.gov.au",
        "Sormeh.Sharifi@dcceew.gov.au",
        "Stefanie.Straub@dcceew.gov.au",
        "stu.reeh@dcceew.gov.au",
        "Tonny.Tang@csiro.au",
        "tool.testing@nathers.gov.au",
        "trials@nathers.gov.au",
        "watson.assessor@gmail.com",
        "yongbing.khoo@csiro.au",
        "Zahra.Abbasi@dcceew.gov.au",
        "zainab.iqbal@dcceew.gov.au",
        "abhishek.godhani@csiro.au",
        "accreditation.thermal.modify@csiro.au",
        "accreditation.thermal.orderby@csiro.au",
        "accreditation.thermal@csiro.au",
        "accreditation.thermal2@csiro.au",
        "accreditation.thermal241011@csiro.au",
        "accreditation.thermal241011test@csiro.au",
        "accreditation.thermal250529@csiro.au",
        "accreditation.thermal250814@csiro.au",
        "accreditation.woh@csiro.au",
        "accreditation.woh241025@csiro.au",
        "accreditation.woh250610@csiro.au",
        "accreditation.woh250611@csiro.au",
        "accurateenterprise.admin@csiro.au",
        "accurateenterprise.andrew@csiro.au",
        "accurateenterprise.assessor@csiro.au",
        "accurateenterprise.test@csiro.au",
        "ai.jian@csiro.au",
        "angela.rojas@csiro.au",
        "brad.lane@csiro.au",
        "bradley.lane@csiro.au",
        "Brendan.Chan@dcceew.gov.au",
        "karen.brock@csiro.au",
        "lachlan.cheers@csiro.au",
        "lachlan.mudge@dcceew.gov.au",
        "madrox@csiro.au",
        "melanie.lupis@dcceew.gov.au",
        "melissa.james@csiro.au",
        "michael.ambrose@csiro.au",
        "ming.liu1@csiro.au",
        "mitch.tucker@csiro.au",
        "nathers.assessor@csiro.au",
        "sormeh.sharifi@dcceew.gov.au",
        "stefanie.straub@dcceew.gov.au",
        "tonny.tang@csiro.au",
        "tool.testing@nathers.gov.au",
        "yongbing.khoo@csiro.au",
        "zainab.iqbal@dcceew.gov.au",
        "zhengen.ren@csiro.au",
        "accurateenterprise.admin@csiro.au",
        "accurateenterprise.assessor@csiro.au",
        "ai.jian@csiro.au",
        "alice.wade1@dcceew.gov.au",
        "andrew.law@csiro.au",
        "angela.rojas@csiro.au",
        "batch.testing@nathers.gov.au",
        "Ben.Kennedy@dcceew.gov.au",
        "bradley.lane@csiro.au",
        "Brendan.Chan@dcceew.gov.au",
        "christine.kerr@dcceew.gov.au",
        "clare.smith@dcceew.gov.au",
        "daniel.daly@dcceew.gov.au",
        "daniella.amiyants1@dcceew.gov.au",
        "dave.brunoro1@dcceew.gov.au",
        "ellen.pearson@dcceew.gov.au",
        "Grady.Peterson@dcceew.gov.au",
        "John.DAVEY@dcceew.gov.au",
        "Katie.Glendenning@dcceew.gov.au",
        "lachlan.brennan@dcceew.gov.au",
        "lachlan.cheers@csiro.au",
        "Lachlan.Mudge@dcceew.gov.au",
        "lan359@csiro.au",
        "matt.marchesi@dcceew.gov.au",
        "Melanie.Lupis@dcceew.gov.au",
        "michael.ambrose@csiro.au",
        "ming.liu1@csiro.au",
        "nesreen.abumousa@dcceew.gov.au",
        "Rowan.Hearne@dcceew.gov.au",
        "Shlomi.Bonet@dcceew.gov.au",
        "Sormeh.Sharifi@dcceew.gov.au",
        "Stefanie.Straub@dcceew.gov.au",
        "stu.reeh@dcceew.gov.au",
        "tonny.tang@csiro.au",
        "tool.testing@nathers.gov.au",
        "trials@nathers.gov.au",
        "watson.assessor@gmail.com",
        "yongbing.khoo@csiro.au",
        "Zahra.Abbasi@dcceew.gov.au",
        "zainab.iqbal@dcceew.gov.au",
        "aforero@urbis.com.au",
        "hallan@urbis.com.au",
        "sumitk@suho.com.au",
        "breynolds@urbis.com.au",
        "Upgrade.Prod-20251022@csiro.au",
        "Upgrade.Dev-20251022@csiro.au",
        "katie.glendenning@dcceew.gov.au",
        "nh.mu.testing-dev@nathers.gov.au",
        "nh.mu.testing-uat@nathers.gov.au",
        "nh.mu.testing-prod@nathers.gov.au",
        "eh.testing-dev@nathers.gov.au",
        "eh.testing-uat@nathers.gov.au",
        "eh.testing-prod@nathers.gov.au",
      ].map(str => str.toLowerCase());
      if (authorityAccounts.includes(userName === null || userName === undefined ? "AAA" : userName.toLowerCase())){
        items.batchProcess = {
          name: "Batch Process",
          icon: "",
          defaultAction: false,
          disabled: function () {
            return dataExtension.getSelectedRowDataIds(data).length === 0 || dataExtension.getSelectedRowDataIds(data).length > 5;
          },
        };
      }

  const contextMenu = {
    items: items,
    callBack: (
      contextMenuCallBackKey,
      contextMenuCallBackElement,
      contextMenuCallBackTableRoadData,
      localtion
    ) => {
      if (contextMenuCallBackKey === "delete") {
        setModal({
          ...modal,
          isOpen: true,
          title: "Delete projects",
          message:
            "Are you sure you want to delete " +
            dataExtension.getSelectedRowDataIds(data).length +
            " selected project(s)?",
          comfirmButtonStyle: "danger",
          comfirmButtonText: "Confirm to delete",
          handleComfirm: handleDeleteComfirm,
        });
      }
      if (contextMenuCallBackKey === "duplicateIncludeDevelopment") {
        setModal({
          ...modal,
          isOpen: true,
          title: "Duplicate projects Including Development",
          message:
            "Are you sure you want to duplicate " +
            dataExtension.getSelectedRowDataIds(data).length +
            " selected project(s) including Development(s)?",
          comfirmButtonStyle: "primary",
          comfirmButtonText: "Confirm to duplicate",
          handleComfirm: handleDuplicatedIncludingDevelopmentComfirm,
        });
      }

      if (contextMenuCallBackKey === "duplicate") {
        setModal({
          ...modal,
          isOpen: true,
          title: "Duplicate projects",
          message:
            "Are you sure you want to duplicate " +
            dataExtension.getSelectedRowDataIds(data).length +
            " selected project(s)?",
          comfirmButtonStyle: "primary",
          comfirmButtonText: "Confirm to duplicate",
          handleComfirm: handleDuplicatedComfirm,
        });
      }

      if (contextMenuCallBackKey === "batchProcess") {
        const projectIds = dataExtension.getSelectedRowDataIds(data);
        var projectIdsJson = stringCoding.encode(JSON.stringify(projectIds));
        const url = "/BatchProcessProjects/Detail/" + projectIdsJson + "/" + redirectUrlHex;
        window.open(url, '_blank');
      }
    },
  };

  function getSelectedDevelopmentId(){
    const developmentIds = extraPostModelDevelopment.selectedItemIds;
      if (developmentIds.length === 0) return emptyGuid;
      const developmentId = developmentIds[0];
      return developmentId;
  }

  const handleDeleteComfirm = async () => {
    setLoading({isLoading:true,text:"Deleting projects"});
    await tryCatchFinally.asyncProcess(async ()=>{
      const selectedItemIds = dataExtension.getSelectedRowDataIds(data);
      const deleteResponse = await getData.processPost(
        true,
        "api/Project/Accessor/Delete",
        {selectedItemIds:selectedItemIds}
      );
      setTableReload(guid.newGuid());
      toastPrint.printResponse(deleteResponse);
    }, setLoading);
  };

  const handleDuplicatedIncludingDevelopmentComfirm = async () => {
    setLoading({isLoading:true,text:"Duplicating projects"});
    await tryCatchFinally.asyncProcess(async ()=>{
      const selectedItemIds = dataExtension.getSelectedRowDataIds(data);
      const deleteResponse = await getData.processPost(true, "api/Project/Accessor/CopyIncludeDevelopment", {selectedItemIds: selectedItemIds});
      setTableReload(guid.newGuid());
      toastPrint.printResponse(deleteResponse);
    }, setLoading);
  };

  const handleDuplicatedComfirm = async () => {
    setLoading({isLoading:true,text:"Duplicating projects"});
    await tryCatchFinally.asyncProcess(async ()=>{
      const selectedItemIds = dataExtension.getSelectedRowDataIds(data);
      const deleteResponse = await getData.processPost(true, "api/Project/Accessor/Copy", {selectedItemIds: selectedItemIds});
      setTableReload(guid.newGuid());
      toastPrint.printResponse(deleteResponse);
    }, setLoading);
  };

  useEffectWithPrevious((previous)=>{
    if(previous !== undefined && previous !== null && previous[0] !== undefined && previous[0] !== null){
      const previousJson = JSON.stringify(previous[0]);
      const presentJson = JSON.stringify(data);
      if(previousJson !== presentJson){
        setData((oldState)=>{
          const dataClone = [...oldState];
          for(let i = 0; i < dataClone.length; i++){
            try{
              const dateString = dataClone[i].submittedDate;
              const localTime = timeOperation.convertUtcToLocalDate(dateString);
              if(localTime !== "Invalid Date"){
                dataClone[i].submittedDate = localTime;
              }
            }catch{}
          }
          return dataClone;
        });
      }
    }
  },[data]);

  return (
    <Fragment>
      <ModalDatatableItem
        modal={modal}
        setModal={setModal}
      ></ModalDatatableItem>
       {debug &&  <p> Selected items:  {JSON.stringify(extraPostModelProject.selectedItemIds)} </p>}
      <div id="ProjectsAccordion">
        <div className="main-card mb-3 card">
          <div className="card-header">
            <button
              type="button"
              data-toggle="collapse"
              data-target="#ProjectsCollapsibleDiv"
              aria-expanded="true"
              aria-controls="ProjectsCollapsibleDiv"
              className="text-left m-0 p-0 btn btn-block"
            >
              <h5 className="m-0 p-0 card-title">Projects of selected developments<TooltipTemplate text={"This table displays the project(s) associated with the selected Development(s) from the Developments table.\nIf no Development(s) are selected, all saved projects will be shown."} result={0} color="grey" /></h5>
            </button>
              <div style={{marginLeft:"15px"}} className="page-title-subheading">
                  <a className="btn btn-primary" target="_blank" href="/ProjectAssessor/ImportProject">Import project</a>
              </div>
          </div>
          <div id="ProjectsCollapsibleDiv" className="collapse show">
            <div className="card-body">           
              {loading.isLoading && <AppLoading active><div>{loading.text}</div></AppLoading>}
              <ServerSideDataTable
                id={tableId}
                location="Project"
                data={data}
                setData={setData}
                reload={tableReload}
                columns={columns}
                actionOnDoubleClickRow
                allowSelect
                allowSelectMultiple
                dataSource={{ isAuth: true, url: "api/Project/Accessor" }}
                contextMenu={contextMenu}
                extraPostModel={extraPostModelDevelopment}
                setSelectedItemIds = {setExtraPostModelProject}
              ></ServerSideDataTable>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
export default ProjectDataTable;
